import api from '../assets/Postman.png';
import flask from '../assets/flask.png';
import selenium from '../assets/selenium.png';
import css from '../assets/css.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import QA from '../assets/qa.png';
import Kaushal from '../assets/Kaushal.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';
import gmail from '../assets/Gmail.png';
import phone from '../assets/phone.png';
import django from '../assets/django.png';
import n8n from '../assets/n8n.png';
import docker from '../assets/docker.png';
import azure from '../assets/azure.png';
import drf from '../assets/DRF.png';

// Assign the object to a variable before exporting
const images = {
  api,
  flask,
  selenium,
  css,
  git,
  html,
  javascript,
  python,
  react,
  QA,
  Kaushal,
  circle,
  logo,
  gmail,
  phone,
  django,
  n8n,
  docker,
  azure,
  drf
};

export default images;
